import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import vuetify from './plugin/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(VueSweetalert2);
Vue.use(VueReCaptcha, { siteKey: '6LdFJ1QgAAAAAMfX6qVRPQXaeBw3858wvIsLT8AE' })
Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)
Vue.use(Toast, {
  position: 'top-center',
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  draggable: false,
  hideProgressBar: false,
})
Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
